
<div class="hbox" *ngIf="investigation">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb">
          <li><a routerLink="/products/investigations">Investigations</a></li>
          <li>{{investigation.name}}</li>
        </ul>
        <div class="pull-right">
          <a class="fa fa-pencil-square-o pointer" routerLink="edit"></a>
        </div>
      </div>
    </div>
    <div class="flex-content p-4">
      <div class="col-xs-12 flex mt-0">
        <label class="col-xs-2">Name</label>
        <div class="col pull-left">:</div>
        <div class="col-xs-8">{{investigation.name}}</div>
      </div>
      <div class="col-xs-12 flex" *ngIf="investigation.description">
        <label class="col-xs-2">Description</label>
        <div class="col pull-left">:</div>
        <div class="col-xs-8">{{investigation.description}}</div>
      </div>
      <div class="col-xs-12 flex">
        <label class="col-xs-2">Tests</label>
        <div class="col pull-left">:</div>
        <div class="col-xs-8">
          <ng-container *ngIf="investigation.tests?.length; else noTests">
            <span class="label m-r-xs m-b-xs dib" [ngClass]="test.required ? 'label-primary' : 'label-default'" *ngFor="let test of investigation.tests">{{test.test}}<span *ngIf="!test.required" class="ml-1">(optional)</span></span>
          </ng-container>
          <ng-template #noTests><span>-</span></ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
